import { connect } from "react-redux";
import Verification from "../components/Verification";
import { requestVerification } from "../actions/verificationActions";

function mapStateToProps( state, ownProps ) {
    return {
        status: state.verification.status,
        uid: ownProps.match.params.uid,
        code: ownProps.match.params.code
    };
}

function mapDispatchToProps( dispatch, ownProps ) {
    return {
        verify: ( verification ) => requestVerification( dispatch, verification )
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Verification );